import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fromPairs } from 'lodash';
import { Preview, Editor, LanguageSelector } from 'components';
import presets, { themePreset } from './theme-presets';

class LockPlayground extends Component {
  static propTypes = {
    defaultsLogosBaseUrl: PropTypes.string,
    defaultColor: PropTypes.string,
    logos: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired
    }).isRequired),
    hideName: PropTypes.bool
  }

  static defaultProps = {
    defaultsLogosBaseUrl: 'https://cdn.auth0.com/website/playground/others/'
  }

  state = {
    options: presets.login,
    preset: 'login',
    selectedLanguageIndex: 0
  }

  setPreset = (name) => {
    const options = presets[name];
    if (options) {
      this.setState({ preset: name, options });
    }
  }

  setOption = (name, value) => {
    const options = this.state.options.map(option => {
      const isName = option[0] === name;

      return isName
        ? [name, value]
        : option;
    });

    this.setState({ options });
  }

  setSelectedType = (index) => {
    this.setState({
      selectedLanguageIndex: index
    });
  }

  render() {
    const { defaultColor, logos } = this.props;
    const { options } = this.state;

    const themePresetOptions = themePreset.map(opt => opt[0]);

    const themeObj = [
      'theme',
      fromPairs(
        options.filter(opt => themePresetOptions.includes(opt[0]))
      )
    ];

    const optionsWithTheme = options
      .filter(opt => !themePresetOptions.includes(opt[0]))
      .concat([themeObj]);

    const optionsString = getOptionsString(
      optionsWithTheme,
      { defaultColor, logos, logoBaseUrl: this.props.defaultsLogosBaseUrl }
    );

    const optionsObj = getOptionsObj(
      optionsWithTheme,
      { defaultColor, logos, logoBaseUrl: this.props.defaultsLogosBaseUrl }
    );

    const preview = (
      <Preview
        optionsString={optionsString}
        options={optionsObj}
        hideName={this.props.hideName}
      />
    );

    const editor = (
      <Editor
        selectedLanguageIndex={this.state.selectedLanguageIndex}
        onOptionChange={this.setOption}
        options={this.state.options}
        preset={this.state.preset}
        logoBaseUrl={this.props.defaultsLogosBaseUrl}
        logos={this.props.logos}
        defaultColor={this.props.defaultColor}
        hideName={this.props.hideName}
        optionsString={optionsString}
      />
    );

    return (
      <div className="lock-playground">
        <LanguageSelector
          selectedLanguageIndex={this.state.selectedLanguageIndex}
          handleItemClick={this.setSelectedType}
        />
        <div className="editor-section">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-md-7">
                { editor }
              </div>
              <div className="col-md-5 hidden-xs hidden-sm">
                { preview }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LockPlayground;

function getOptionsString(options, { defaultColor, logos, logoBaseUrl }) {
  return options.map(o => {
    if (o[0] === 'theme') {
      const value = {};

      if (o[1].logo !== 'default') {
        value.logo = (logoBaseUrl || '') + o[1].logo;
      } else if (logos) {
        value.logo = logos[0].icon;
      }

      if (o[1].primaryColor !== 'default') {
        value.primaryColor = o[1].primaryColor;
      } else if (defaultColor) {
        value.primaryColor = defaultColor;
      }

      return `${o[0]}: ${JSON.stringify(value)}`;
    }

    return `${o[0]}: ${JSON.stringify(o[1])}`;
  }).join(',\n');
}

function getOptionsObj(options, { defaultColor, logos, logoBaseUrl }) {
  return options.reduce((prev, curr) => {
    if (curr[0] === 'theme') {
      prev.theme = {};

      if (curr[1].logo !== 'default') {
        prev.theme.logo = (logoBaseUrl || '') + curr[1].logo;
      } else if (logos) {
        prev.theme.logo = logos[0].icon;
      }

      if (curr[1].primaryColor !== 'default') {
        prev.theme.primaryColor = curr[1].primaryColor;
      } else if (defaultColor) {
        prev.theme.primaryColor = defaultColor;
      }
    } else {
      prev[curr[0]] = curr[1];
    }
    return prev;
  }, {});
}



// WEBPACK FOOTER //
// ./src/components/LockPlayground/LockPlayground.js


// WEBPACK FOOTER //
// webpack:///src/components/LockPlayground/LockPlayground.js